/* eslint-disable react/prop-types */
import React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import ApplicationStageSelectorInput from "../../ApplicationStageSelectorInput";
import RequirementCategorySelectorInput from "../../RequirementCategorySelectorInput";
import RequirementNameInput from "../../RequirementNameInput";

//import styles
import { _FilterWrapper } from "./style";
import { SELECT_REQUIREMENT_FILTER_IDENTIFIER } from "../../../constants/consts";
var SelectRequirementFilterPresentation = function SelectRequirementFilterPresentation(_ref) {
  var className = _ref.className,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    id: id
  }, /*#__PURE__*/React.createElement(_FilterWrapper, null, /*#__PURE__*/React.createElement(ApplicationStageSelectorInput, {
    clearable: true,
    fieldName: "application_stage",
    placeholder: "Stage",
    useValue: true
  }), /*#__PURE__*/React.createElement(RequirementCategorySelectorInput, {
    clearable: true,
    fieldName: "requirement_category",
    placeholder: "Category",
    useValue: true
  }), /*#__PURE__*/React.createElement(RequirementNameInput, {
    fieldName: "requirement_id",
    paddingRight: "0",
    placeholder: "Requirement ID / Internal Name"
  })));
};
var selectRequirementFilterEnhancer = compose(reduxForm({
  form: SELECT_REQUIREMENT_FILTER_IDENTIFIER
}));
var SelectRequirementFilter = selectRequirementFilterEnhancer(SelectRequirementFilterPresentation);
export default SelectRequirementFilter;